import type BackOfficeConnector from "../data/backOfficeConnector";
import type EventBus from "services/eventBus";
import RepositoryBase from "./repositoryBase";
import type { IListRepository } from "./types";
import EnforcementTabletResponse from "entities/enforcementTabletResponse";
import type UpdateEnforcementTabletRequest from "entities/updateEnforcementTabletRequest";
import CreateEnforcementTabletRequest from "entities/createEnforcementTabletRequest";
import type IncludeDeletedPaginatedRequest from "entities/includeDeletedPaginatedRequest";

export default class EnforcementTabletRepository
  extends RepositoryBase<BackOfficeConnector>
  implements IListRepository<EnforcementTabletResponse>
{
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  create(entity: CreateEnforcementTabletRequest) {
    return this.callApi(api => api.all("enums").one("enforcement_tablets").postEntity(entity, CreateEnforcementTabletRequest));
  }

  get(id: string) {
    return this.callApi(api =>
      api.all("enums").one("enforcement_tablets", id).getEntity<EnforcementTabletResponse>(EnforcementTabletResponse)
    );
  }

  getAll(queryParams: IncludeDeletedPaginatedRequest) {
    return this.callApi(api =>
      api.all("enums").all("enforcement_tablet_search").postPagedEntities(queryParams, EnforcementTabletResponse)
    );
  }

  update(id: string, entity: UpdateEnforcementTabletRequest) {
    return this.callApi(api => api.all("enums").one("enforcement_tablets", id).putEntity(entity, EnforcementTabletResponse));
  }

  delete(id: string) {
    return this.callApi(api => api.all("enums").one("enforcement_tablets", id).delete(id));
  }
}
